// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2923d386","239":"c2aa574f","455":"5cbbd674"}[chunkId] + ".chunk.js";
};